import React from 'react';
import UserAvatar from 'treeline-react-core-components/UserAvatar';
import { UserListLink } from '../UI/UserListLink';
import { ReviewRatingWithMuchLove } from '../UI/ReviewRatingWithMuchLove';
import { ClickableReviewText } from '../UI/ClickableReviewText';
import ReviewDate from '../UI/ReviewDate';

export class MostRecentReview extends React.Component {
	constructor(props) {
		super(props);

		var row = this.props.row;
		var review = this.getMostRecentReview(row.reviews);
		var userAvatar = row.userAvatars[review.appUserId];
		var userInfo = row.userInfo[review.appUserId];
		var orgInfo = {};
		if (row.userInfo[review.appUserId].orgID.toLowerCase() in row.orgInfo) {
			orgInfo =
				row.orgInfo[row.userInfo[review.appUserId].orgID.toLowerCase()];
		}
		var userId = review.appUserId;
		var createdDateAsDateObject = new Date(review.createdDate);

		this.state = {
			review: review,
			userAvatar: userAvatar,
			userInfo: userInfo,
			orgInfo: orgInfo,
			userId: userId,
			createdDateAsDateObject: createdDateAsDateObject,
		};
	}

	getMostRecentReview = reviews => {
		reviews.sort(function(r1, r2) {
			var date1 = new Date(r1.createdDate);
			var date2 = new Date(r2.createdDate);
			return date2 - date1;
		});
		return reviews[0];
	};

	render() {
		return (
			<div>
				<div className="column">
					<div className="bold">Most recent review</div>
					<hr className="most-recent-review-header-content-separator" />
				</div>
				<div className="clear">
					<div className="column">
						<UserAvatar
							userInitials={this.state.userAvatar.initials}
							avatarUri={this.state.userAvatar.url || null}
							displayName={this.state.userAvatar.displayName}
							avatarSizeClass={`avatar-${
								this.state.userAvatar.size
							}`} // `
						/>
					</div>
					<div className="column-spaced">
						<UserListLink
							userId={this.state.userId}
							userName={this.state.userInfo.fullName}
							orgName={this.state.orgInfo.name}
							orgId={this.state.userInfo.orgID}
							userListLinkClass="text-small"
							includeOrg
							linksOff
						/>
					</div>
				</div>
				<div className="clear">
					<span className="column">Rating:</span>
					<span className="column margin-left-5">
						<ReviewRatingWithMuchLove
							rating={this.state.review.rating}
						/>
					</span>
				</div>
				{this.state.review.hasReviewText ? (
					<div className="clear">
						<span className="column">Review:</span>
						<span className="column margin-left-5">
							<ClickableReviewText
								appUserId={this.state.review.appUserId}
								sku={this.state.review.sku}
								reviewText={this.state.review.abstract}
								communityId={this.props.communityId}
								reviewsCreatedDateMaxDaysBack={
									this.props.reviewsCreatedDateMaxDaysBack
								}
								setUserTitleReviewModalState={
									this.props.setUserTitleReviewModalState
								}
							/>
						</span>
					</div>
				) : (
					''
				)}
				<div className="clear">
					<ReviewDate
						reviewedDate={this.state.createdDateAsDateObject}
					/>
				</div>
			</div>
		);
	}
}
